import React, { memo } from 'react';
import MuxPlayer from '@mux/mux-player-react';
// eslint-disable-next-line import/no-unresolved
import '@mux/mux-player/themes/minimal';
import imageUrlGenerator from '../../utils/imageUrlGenerator';
import PlaceholderPicture from './styles';
import colors from '../../constants/colors';

const ABSOLUTE_URL_REGEX = /^https?:\/\//i;

const normalizePictureInput = input => {
  if (!input) {
    return null;
  }

  if (typeof input === 'string') {
    return input;
  }

  if (typeof input === 'object') {
    if (input.fileName) {
      return input.fileName;
    }

    if (input.url) {
      return input.url;
    }
  }

  return null;
};

const buildPictureUrl = input => {
  const normalized = normalizePictureInput(input);

  if (!normalized) {
    return null;
  }

  if (ABSOLUTE_URL_REGEX.test(normalized)) {
    return normalized;
  }

  return imageUrlGenerator(normalized, '640x360', '360x200');
};

const DefaultVideoPlayer = ({
  video,
  placeholderPicture,
  autoPlay = false,
  muted = false,
  loop = false,
  playsInline = true,
  onEnded,
  onReady,
  poster,
  controls = false,
  className,
}) => {
  const fallbackPreview = placeholderPicture || video?.previewPicture || null;
  const posterSource = poster || buildPictureUrl(fallbackPreview);
  const wrapperClassName = ['default-video-player', className].filter(Boolean).join(' ');

  if (!video || !video.muxPlaybackId) {
    return (
      <div className={wrapperClassName}>
        <PlaceholderPicture
          className="default-video-placeholder"
          style={posterSource ? { backgroundImage: `url(${posterSource})` } : undefined}
        />
      </div>
    );
  }

  return (
    <div className={wrapperClassName}>
      <MuxPlayer
        className="default-video-player__mux"
        style={{ width: '100%', height: '100%' }}
        theme="minimal"
        accentColor={colors.main.lightBlue}
        playbackId={video.muxPlaybackId}
        poster={posterSource || undefined}
        autoPlay={autoPlay}
        muted={muted}
        loop={loop}
        playsinline={playsInline}
        preload="auto"
        controls={controls}
        onEnded={onEnded}
        onLoadedData={onReady}
        metadata={{
          title: video.title || video.originalName,
          id: video.id,
        }}
        streamType="on-demand"
      />
    </div>
  );
};

export default memo(DefaultVideoPlayer);
